class BnplContainer extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els['open-button'].element,
      'click',
      this.openClick.bind(this),
    )

    this.addEventListener('mouseover', this.openFocus.bind(this))
    this.addEventListener('mouseout', this.closeFocus.bind(this))
    this.addEventListener('focusin', this.openFocus.bind(this))
    this.addEventListener('focusout', this.closeFocus.bind(this))

    this.listeners.add(
      this.els['product-button'].element,
      'click',
      this.closeInfo.bind(this),
    )
    this.listeners.add(
      this.els['close-button'].element,
      'click',
      this.closeInfo.bind(this),
    )

    this.listeners.add(document.body, 'click', this.handleBodyClick.bind(this))
  }

  openClick () {
    if (window.innerWidth < 901) {
      this.openInfo()
    }
  }

  openFocus () {
    if (window.innerWidth > 900) {
      this.openInfo()
    }
  }

  closeFocus () {
    if (window.innerWidth > 900) {
      this.closeInfo()
    }
  }

  handleBodyClick (event) {
    if (!document.body.classList.contains('lyt-Theme-bnplOpen')) return
    if (this.contains(event.target)) return
    this.closeInfo()
  }

  openInfo () {
    this.els.details.element.classList.add('prd-Finances_Options-open')
    if (window.innerWidth < 901) {
      document.body.classList.add('lyt-Theme-bnplOpen')
    }
  }

  closeInfo () {
    this.els.details.element.classList.remove('prd-Finances_Options-open')
    if (window.innerWidth < 901) {
      document.body.classList.remove('lyt-Theme-bnplOpen')
    }
  }
}

if (!customElements.get('bnpl-container')) {
  customElements.define('bnpl-container', BnplContainer)
}
